import { PERMISSIONS } from '../../common/constants'

const REPORT_ROUTES = {
  USERS: {
    name: 'User Reports',
    link: '/reports/users',
    key: 'reports-user',
    permissions: [PERMISSIONS.REPORT.GET_FOR_USERS],
  },
  METADATA_NODES: {
    name: 'Metadata Nodes',
    link: '/reports/metadata-nodes',
    key: 'reports-metadata-nodes',
    permissions: [PERMISSIONS.REPORT.METADATA_NODES],
  },
}

export default REPORT_ROUTES
